<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      right
      shadow
      z-index="1051"
      width="320px"
      :backdrop="!isPinned"
      backdrop-variant="none"
      :no-close-on-backdrop="isPinned"
      @shown="sidebarOpen"
      @hidden="sidebarClose"
    >
      <template #header>
        <div>
          <div class="container-header-sidebar">
            <div>
              <b-icon-x
                variant="light"
                class="mt-1"
                v-b-toggle.sidebar-right
              ></b-icon-x>
              <b-icon-pin
                v-if="!isPinned"
                @click="togglePin"
                class="mt-1"
                scale="0.7"
                v-b-tooltip.v-secondary.top.noninteractive="
                  $t('reusable.aiComponent.pinMenu')
                "
              ></b-icon-pin>
              <b-icon-pin-fill
                v-else
                @click="togglePin"
                class="mt-1"
                scale="0.7"
                v-b-tooltip.v-secondary.top.noninteractive="
                  $t('reusable.aiComponent.unpinMenu')
                "
              ></b-icon-pin-fill>
            </div>

            <h4>{{ $t("reusable.aiComponent.artificialIntelligence") }}</h4>
          </div>
          <p class="header-subtitle m-0 p-0">
            {{ $t("reusable.aiComponent.artificialIntelligenceSubtitle") }}
          </p>
        </div>
      </template>

      <!-- TABS -->
      <b-tabs justified card class="custom-tabs" v-model="active_tab">
        <!-- TAB GENERADOR -->
        <b-tab
          :title="$t('reusable.aiComponent.generator')"
          active
          class="px-0 pt-2"
        >
          <FirstTab
            @change-tab="handleTabChange"
            @update-results="handleResultsUpdate"
          ></FirstTab>
        </b-tab>

        <!-- TAB DE RESULTADOS -->
        <b-tab :title="$t('reusable.aiComponent.results')" class="px-0 pt-2">
          <SecondTab
            :result_examples="result_examples"
            :is_loading="is_loading"
            :error_message="error_message"
          ></SecondTab>
        </b-tab>
      </b-tabs>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: "AiSidebar",
  components: {
    FirstTab: () => import("@/components/reusable/ai-component/FirstTab"),
    SecondTab: () => import("@/components/reusable/ai-component/SecondTab"),
  },
  props: {},
  data() {
    return {
      isPinned: false, // Controla si el sidebar está fijado o no
      active_tab: 0, // Variable para mostrar los "tabs"
      state_sidebar: false, // Variable para determianr si está abierto o no el sidebar
      modalObserver: null, // Variable para detectar cambios en el DOM
      // Variables para compartir con SecondTab
      result_examples: [],
      is_loading: false,
      error_message: null,
    };
  },
  computed: {},
  methods: {
    // Métodos para manejar eventos de FirstTab
    handleTabChange(tabIndex) {
      this.active_tab = tabIndex;
    },
    handleResultsUpdate(data) {
      this.result_examples = data.examples;
      this.is_loading = data.loading;
      this.error_message = data.error;
    },
    togglePin() {
      this.isPinned = !this.isPinned; // Cambia entre fijado y no fijado
    },
    sidebarOpen() {
      this.state_sidebar = true;
      this.applyModalTransform(); // Aplicar el estilo a los modals ya abiertos
      this.startObservingModals(); // Configurar el observador para detectar nuevos modals
    },
    sidebarClose() {
      this.state_sidebar = false;
      this.resetModalTransform(); // Restablecer el estilo de los modals
      this.stopObservingModals(); // Detener el observador
    },
    applyModalTransform() {
      // Seleccionar todos los modals abiertos y aplicarles el estilo
      const modals = document.querySelectorAll(".modal-open .modal");
      modals.forEach((modal) => {
        if (modal.style.transform != "translateX(-10%)") {
          modal.style.transform = "translateX(-10%)";
          modal.style.transition = "transform 0.3s ease";
        }
      });
    },
    startObservingModals() {
      // Crear un observador que detecte cambios solo en los modals
      this.modalObserver = new MutationObserver((mutationsList) => {
        // Solo se activa si el sidebar está abierto
        if (
          this.state_sidebar &&
          mutationsList.some(
            (x) =>
              x.target.classList && x.target.classList.contains("modal-open")
          )
        ) {
          this.applyModalTransform();
        }
      });

      // Observar cambios en el body, pero filtramos solo los cambios relevantes
      this.modalObserver.observe(document.body, {
        childList: true, // Detecta adición y eliminación de nodos
        subtree: true, // Observa todos los descendientes, no solo el body
      });
    },
    resetModalTransform() {
      // Seleccionar todos los modals abiertos y restablecer el estilo
      const modals = document.querySelectorAll(".modal-open .modal");
      modals.forEach((modal) => {
        modal.style.transform = "";
      });
    },
    stopObservingModals() {
      // Desconectar el observador si está activo
      if (this.modalObserver) {
        this.modalObserver.disconnect();
        this.modalObserver = null;
      }
    },
  },
  watch: {},
  mounted() {},
  created() {},
  beforeDestroy() {
    // Detener el observador al destruir el componente
    this.stopObservingModals();
  },
};
</script>

<style scoped>
/* Fondo del sidebar con el mismo gradiente azul que usa Toolbar */
div >>> #sidebar-right {
  background: linear-gradient(
    180deg,
    var(--kl-color-primary-deep) 0%,
    var(--kl-color-primary) 60%,
    var(--kl-color-secondary) 120%
  );
}
div >>> #sidebar-right .b-sidebar-header,
div >>> #sidebar-right .b-sidebar-body {
  background: transparent;
}
.container-header-sidebar {
  display: flex;
  color: white;
  max-height: 30px;
}
.header-subtitle {
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-regular);
  line-height: 1;
  color: rgba(255, 255, 255, 0.8);
}
.custom-tabs {
  padding: 5px !important;
}
.custom-tabs >>> .card-header-tabs {
  margin-right: 0;
}
div >>> .card-header {
  padding: 6px 6px;
}
.custom-tabs >>> .nav-link.active {
  background-color: #007bff;
  color: white;
  font-weight: bold;
  border-color: #007bff;
  padding: 0.4rem;
}

.custom-tabs >>> .nav-link {
  background-color: var(--kl-color-accent-soft);
  color: var(--kl-color-accent);
  border-color: #ddd;
  padding: 0.4rem;
}
</style>